/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { MyPolicy } from '../../auth/core/_models'
import { WilliamsleaParentalEnrollmentListModel } from './WilliamsleaParentalEnrollmentListModel'

const PARENT_CLIENT_CODE = 'FIB00001232C'
const PARENT_IN_LAW_CLIENT_CODE = 'FIB00001233C'

type Props = {
  className: string
  title: string
  description: string
  avatar: string
  Email: string | undefined
  CrmUrl: string | undefined
  MyPolicy: MyPolicy | null
  onRefresh?: () => void
}

const WilliamsleaParentalEnrollmentLinkWidget: React.FC<Props> = ({ className, title, description, avatar, Email, CrmUrl, MyPolicy, onRefresh }) => {
  const [modalShow, setModalShow] = useState(false)

  const handleClose = () => {
    setModalShow(false)
    onRefresh?.()
  }

  const crmDbName = MyPolicy?.Policy.CrmDbName || ''
  const buttonLabel =
    crmDbName === PARENT_IN_LAW_CLIENT_CODE
      ? 'Enroll Parents-in-law'
      : 'Enroll Parents'

  return (
    <>
      <a className={` hoverable`} onClick={() => setModalShow(true)}>
        <div className='border bg-light-primary border-primary border-dashed rounded 
                           py-3 px-4 me-6 mb-3 border-hover-success 
                          bg-hover-primary text-hover-white'>
          <div className='d-flex align-items-center'>
            <div className='fs-6 fw-bolder'>{buttonLabel}</div>
          </div>
        </div>
      </a>

      <WilliamsleaParentalEnrollmentListModel
        show={modalShow}
        handleClose={handleClose}
        Title={title}
        Email={Email}
        CrmUrl={CrmUrl}
        MyPolicy={MyPolicy}
      />
    </>
  )
}

export { WilliamsleaParentalEnrollmentLinkWidget }
